/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    CLEAR_ROMOTION_DATA,
    SET_MFE_BANNER_CODES_ATTEMPTS,
    MFE_PROMOTION_REDIRECT_TO_AFFILIATE,
    MFE_CLEAR_PROMO_AFFILIATE,
    MFE_SET_PROMOTION_LOAD,

    PROMOTION_ADD,
    PROMOTION_REMOVE,
    PROMOTION_SUCCESS,
} from './Promotion-ActionTypes';

export const clearPromotionData = () => ({
    type: CLEAR_ROMOTION_DATA,
});

export const setMfeBannerCodesAttempted = (data) => ({
    type: SET_MFE_BANNER_CODES_ATTEMPTS,
    data,
});

export const mfeRedirectToPromoAffiliate = (affiliatePartner) => ({
    type: MFE_PROMOTION_REDIRECT_TO_AFFILIATE,
    data: affiliatePartner,
});

export const mfeClearPromoAffiliate = () => ({
    type: MFE_CLEAR_PROMO_AFFILIATE,
});

export const mfeApplyPromotionIsLoading = (bool) => ({
    type: MFE_SET_PROMOTION_LOAD,
    payload: bool,
});

export const applyPromotion = (data) => ({
    type: PROMOTION_ADD,
    payload: data,
});

export const promotionRemove = (promoCode, pageType, callbackFn) => ({
    type: PROMOTION_REMOVE,
    payload: {
        promoCode,
        pageType,
        callbackFn,
    },
});

export const promotionSuccess = () => ({
    type: PROMOTION_SUCCESS,
});

export default {};
